export enum accountsModals {
  PLAYER_PROFILE = 'PLAYER_PROFILE',
}
